<template>
  <div class="index-stock">
    <div class="page-title">
      <PageTitle
        class="page-home-title"
        isBack="true"
        link="rh"
        fontSize="25"
        icon="fa fa-cube"
        title="Relatório de Despesas"
      />
    </div>
    <div class="container-report-benefits">
      <iframe :src="url" frameborder="0" allowfullscreen="true"></iframe>
    </div>
  </div>
</template>

<script>
//components
import PageTitle from "@/components/template/PageTitle";
import { baseApiUrlRH } from "@/global";
import axios from "axios";

export default {
  name: "IndexRH",
  components: { PageTitle },
  data() {
    return {
      url: `${baseApiUrlRH}/reportbenefits/`
    };
  },
  methods: {
    loadPerson() {
      let mat = sessionStorage.getItem("@matricula");
      this.url += mat;

      console.log(this.url);
    }
  },
  created() {
    this.loadPerson();
  }
};
</script>

<style scoped src="./style.css">
</style>
